<template>
  <div
    class="fixed top-0 left-0 right-0 flex items-start justify-center"
    style="pointer-events: none"
  >
    <div
      class="pa4 pb0"
    >
      <div class="dark-gray mb2 bb b--moon-gray pb2">
        2 Bedroom Homes
      </div>
      <ul
        v-if="twoBedrooms.length > 0"
        class="list ma0 pa0"
      >
        <li
          v-for="(item, index) in twoBedrooms"
          :key="index"
          class="pv1 f6"
          style="pointer-events: auto"
          :class="{ 'fw6': activeFilter === item.title }"
          @click="toggleActive(item.title)"
        >
          <div class="relative dib v-mid w1 h1 mr2">
            <div
              class="triangle-top absolute top-0 left-0"
              :style="'border-color: ' + item.palette.light + ' transparent transparent transparent'"
            />
            <div
              class="triangle-bottom absolute bottom-0 right-0"
              :style="'border-color: transparent transparent ' + item.palette.dark + ' transparent'"
            />
          </div>
          <div class="dib v-mid lh-title">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
    <div
      class="pa4 pb0"
    >
      <div class="dark-gray mb2 bb b--moon-gray pb2">
        3 Bedroom Homes
      </div>
      <ul
        v-if="threeBedrooms.length > 0"
        class="list ma0 pa0"
      >
        <li
          v-for="(item, index) in threeBedrooms"
          :key="index"
          class="pv1 f6"
          style="pointer-events: auto"
          :class="{ 'fw6': activeFilter === item.title }"
          @click="toggleActive(item.title)"
        >
          <div class="relative dib v-mid w1 h1 mr2">
            <div
              class="triangle-top absolute top-0 left-0"
              :style="'border-color: ' + item.palette.light + ' transparent transparent transparent'"
            />
            <div
              class="triangle-bottom absolute bottom-0 right-0"
              :style="'border-color: transparent transparent ' + item.palette.dark + ' transparent'"
            />
          </div>
          <div class="dib v-mid lh-title">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
    <div
      class="pa4 pb0"
    >
      <div class="dark-gray mb2 bb b--moon-gray pb2">
        4 Bedroom Homes
      </div>
      <ul
        v-if="fourBedrooms.length > 0"
        class="list ma0 pa0"
      >
        <li
          v-for="(item, index) in fourBedrooms"
          :key="index"
          class="pv1 f6"
          style="pointer-events: auto"
          :class="{ 'fw6': activeFilter === item.title }"
          @click="toggleActive(item.title)"
        >
          <div class="relative dib v-mid w1 h1 mr2">
            <div
              class="triangle-top absolute top-0 left-0"
              :style="'border-color: ' + item.palette.light + ' transparent transparent transparent'"
            />
            <div
              class="triangle-bottom absolute bottom-0 right-0"
              :style="'border-color: transparent transparent ' + item.palette.dark + ' transparent'"
            />
          </div>
          <div class="dib v-mid lh-title">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
    <div
      class="pa4 pb0"
    >
      <div class="dark-gray mb2 bb b--moon-gray pb2">
        5 Bedroom Homes
      </div>
      <ul
        v-if="fiveBedrooms.length > 0"
        class="list ma0 pa0"
      >
        <li
          v-for="(item, index) in fiveBedrooms"
          :key="index"
          class="pv1 f6"
          style="pointer-events: auto"
          :class="{ 'fw6': activeFilter === item.title }"
          @click="toggleActive(item.title)"
        >
          <div class="relative dib v-mid w1 h1 mr2">
            <div
              class="triangle-top absolute top-0 left-0"
              :style="'border-color: ' + item.palette.light + ' transparent transparent transparent'"
            />
            <div
              class="triangle-bottom absolute bottom-0 right-0"
              :style="'border-color: transparent transparent ' + item.palette.dark + ' transparent'"
            />
          </div>
          <div class="dib v-mid lh-title">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Legend',
  props: {
    propertyStyles: {
      type: Array,
      default: null
    }
  },
  computed: {
    activeFilter () {
      return this.$store.state.siteplan.filters.style
    },
    columnWidth () {
      let count = 0
      if (this.twoBedrooms.length > 0) { count++ }
      if (this.threeBedrooms.length > 0) { count++ }
      if (this.fourBedrooms.length > 0) { count++ }
      if (this.fiveBedrooms.length > 0) { count++ }
      return (100 / count) + '%'
    },
    twoBedrooms () {
      let array = []
      if (this.propertyStyles !== undefined && this.propertyStyles.length > 0) {
        for (let i = 0; i < this.propertyStyles.length; i++) {
          const element = this.propertyStyles[i]
          if (element.bedrooms === '2') {
            array.push(element)
          }
        }
      }
      return array
    },
    threeBedrooms () {
      let array = []
      if (this.propertyStyles !== undefined && this.propertyStyles.length > 0) {
        for (let i = 0; i < this.propertyStyles.length; i++) {
          const element = this.propertyStyles[i]
          if (element.bedrooms === '3') {
            array.push(element)
          }
        }
      }
      return array
    },
    fourBedrooms () {
      let array = []
      if (this.propertyStyles !== undefined && this.propertyStyles.length > 0) {
        for (let i = 0; i < this.propertyStyles.length; i++) {
          const element = this.propertyStyles[i]
          if (element.bedrooms === '4') {
            array.push(element)
          }
        }
      }
      return array
    },
    fiveBedrooms () {
      let array = []
      if (this.propertyStyles !== undefined && this.propertyStyles.length > 0) {
        for (let i = 0; i < this.propertyStyles.length; i++) {
          const element = this.propertyStyles[i]
          if (element.bedrooms === '5') {
            array.push(element)
          }
        }
      }
      return array
    }
  },
  methods: {
    toggleActive (title) {
      if (this.activeFilter === title) {
        this.$store.commit('setFilterStyle', null)
      } else {
        this.$store.commit('setFilterStyle', title)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .triangle-top,
  .triangle-bottom {
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }
  .triangle-top {
    border-width: 1rem 1rem 0 0;
  }
  .triangle-bottom {
    border-width: 0 0 1rem 1rem;
  }

</style>
